import Header from "../core/Header";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import WhyUs from "../components/WhyUs";
import Sponsors from "../components/Sponsors";
import NewsComponent from "../components/NewsComponent";
import Footer from "../core/Footer";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "../utils/i18n";

function FrontPage() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        backgroundImage: {
          xs: 'linear-gradient(rgba(10, 13, 20, 0.56), rgb(10, 13, 20)), url("/images/frontpage/Autec_at_LOGIMAT_mobile.jpg")',
          md: 'linear-gradient(rgba(10, 13, 20, 0.56), rgb(10, 13, 20)), url("/images/frontpage/Autec_at_LOGIMAT_desktop.jpg")',
        },
        backgroundColor: "#0D1117",
        backgroundSize: { xs: "120% auto", md: "100% auto" },
        backgroundRepeat: "no-repeat",
        backgroundPosition: { xs: "center top", md: "center -100px" },
        minHeight: "75vh",
        width: "100%",
        maxWidth: "100vw",
        overflowX: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Header />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "80vh",
          width: { xs: "96%", sm: "85%", md: "70%" },
          pl: { xs: 2, md: 8 },
          pr: { xs: 2, md: 6 },
        }}
      >
        <Typography
          component="h1"
          sx={{
            color: "white",
            textAlign: "center",
            fontWeight: 500,
            fontSize: { xs: "3rem", md: "4rem" },
            lineHeight: 1.02,
          }}
        >
          {t("hero.title")}
        </Typography>

        <Typography
          component="h2"
          sx={{
            color: "white",
            textAlign: "center",
            mt: 1,
            fontSize: { xs: "1.25rem", md: "1.75rem" },
            fontWeight: 400,
          }}
        >
          {t("hero.subtitle")}
        </Typography>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          sx={{
            mt: 5,
            justifyContent: "center",
            width: "100%",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            component={RouterLink}
            to="/products"
            sx={{
              backgroundColor: "#FF6A00",
              color: "#fff",
              borderRadius: "24px",
              px: { xs: 4, md: 5 },
              py: { xs: 1.25, md: 1.5 },
              fontSize: { xs: "1.0625rem", md: "1.25rem" },
              textTransform: "none",
              "&:hover": { backgroundColor: "#E05500" },
            }}
          >
            {t("hero.ctaProducts")}
          </Button>

          <Button
            variant="outlined"
            component={RouterLink}
            to="/contact"
            sx={{
              color: "#fff",
              borderColor: "#fff",
              borderRadius: "24px",
              px: { xs: 4, md: 5 },
              py: { xs: 1.25, md: 1.5 },
              fontSize: { xs: "1.0625rem", md: "1.25rem" },
              textTransform: "none",
              backgroundColor: "transparent",
              "&:hover": {
                backgroundColor: "rgba(255,255,255,0.06)",
                borderColor: "#fff",
              },
            }}
          >
            {t("hero.ctaContact")}
          </Button>
        </Stack>
      </Box>
      <Box
        sx={{
          width: "100%",
          backgroundColor: "#ffffff",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Sponsors />
      </Box>

      {/* <Box
        sx={{
          width: "100%",
          backgroundColor: "#F6F7F9",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ProductsComponent />
      </Box> */}

      <Box
        sx={{
          width: "100%",
          backgroundColor: "#0D1117",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <WhyUs />
      </Box>

      <Box
        sx={{
          width: "100%",
          backgroundColor: "#ffffff",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <NewsComponent mobileLimit={1} />
      </Box>

      {/* <Box
        sx={{
          width: "100%",
          backgroundColor: "#0D1117",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ContactComponent />
      </Box> */}
      <Footer />
    </Box>
  );
}

export default FrontPage;
